import React, { useState } from "react";

export default function ChatWindow({ selectedContact, messages, onSendMessage }) {
  const [newMessage, setNewMessage] = useState("");

  const handleSend = () => {
    if (!newMessage.trim()) return;
    onSendMessage(newMessage);
    setNewMessage("");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#efeae2", // fundo bege do WhatsApp
      }}
    >
      {/* Cabeçalho */}
      <div
        style={{
          padding: "0.8rem 1rem",
          backgroundColor: "#f0f2f5",
          borderBottom: "1px solid #ddd",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span style={{ fontWeight: "600", color: "#333" }}>
          {selectedContact?.name || "Contato"}
        </span>
        <span style={{ fontSize: "0.9rem", color: "#888" }}>online</span>
      </div>

      {/* Área das mensagens */}
      <div
        style={{
          flex: 1,
          padding: "1.5rem 2rem",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "0.8rem",
        }}
      >
        {messages.map((msg) => (
          <div
            key={msg.id}
            style={{
              display: "flex",
              justifyContent: msg.sender === "user" ? "flex-end" : "flex-start",
            }}
          >
            <div
              style={{
                backgroundColor: msg.sender === "user" ? "#d9fdd3" : "#ffffff",
                borderRadius:
                  msg.sender === "user"
                    ? "10px 0px 10px 10px"
                    : "0px 10px 10px 10px",
                padding: "0.6rem 0.9rem 0.8rem 0.9rem",
                maxWidth: "65%",
                boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
                position: "relative",
                wordBreak: "break-word",
                color: "#111b21",
                fontSize: "0.95rem",
              }}
            >
              {msg.text}
              <span
                style={{
                  fontSize: "0.7rem",
                  color: "#667781",
                  position: "absolute",
                  bottom: "3px",
                  right: "8px",
                }}
              >
                {msg.time}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Campo de envio */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.6rem",
          padding: "0.8rem 1rem",
          backgroundColor: "#f0f2f5",
          borderTop: "1px solid #ddd",
        }}
      >
        <input
          type="text"
          placeholder="Digite uma mensagem..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          style={{
            flex: 1,
            padding: "0.6rem 1rem",
            borderRadius: "20px",
            border: "1px solid #ccc",
            outline: "none",
            fontSize: "0.95rem",
            backgroundColor: "#fff",
          }}
        />
        <button
          onClick={handleSend}
          style={{
            backgroundColor: "#25D366",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "42px",
            height: "42px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            cursor: "pointer",
            fontSize: "0.9rem",
          }}
        >
          ➤
        </button>
      </div>
    </div>
  );
}
